import PageLayout from '@/components/layout/PageLayout';
import Hero from '@/components/features/Hero';
import FeaturesSection from '@/components/features/FeaturesSection';
import ComplianceBadges from '@/components/features/ComplianceBadges';
import EmailSignup from '@/components/features/EmailSignup';
import SeoHead from '@/components/seo/SeoHead';

const JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'Notematic',
  applicationCategory: 'HealthApplication',
  operatingSystem: 'Web',
  url: 'https://www.notematic.com.au',
  description:
    'AI-assisted clinical documentation software for Medicare Mental Health Centres in Australia. Supports 7 clinical note formats — IAR, SOAP, DAP, BIRP, GIRP, PIRP and PIE — with clinician-reviewed drafts, triage notes, and a complete audit trail.',
  offers: [
    {
      '@type': 'Offer',
      name: 'Practice Plan',
      price: '999',
      priceCurrency: 'AUD',
      priceSpecification: { '@type': 'UnitPriceSpecification', unitCode: 'MON' },
    },
    {
      '@type': 'Offer',
      name: 'Centre Plan',
      price: '1799',
      priceCurrency: 'AUD',
      priceSpecification: { '@type': 'UnitPriceSpecification', unitCode: 'MON' },
    },
  ],
  areaServed: { '@type': 'Country', name: 'Australia' },
  provider: { '@type': 'Organization', name: 'Notematic', url: 'https://www.notematic.com.au' },
};

export default function HomePage() {
  return (
    <PageLayout>
      <SeoHead
        title="Notematic — AI-Assisted Clinical Documentation for Mental Health Services | Australia"
        description="Notematic is AI-assisted clinical documentation software for Medicare Mental Health Centres in Australia. Supports 7 clinical note formats — IAR, SOAP, DAP, BIRP, GIRP, PIRP and PIE — with clinician-reviewed drafts, triage notes, and a complete audit trail."
        canonical="/"
        jsonLd={JSON_LD}
      />
      <Hero />
      <FeaturesSection />
      <ComplianceBadges />
      <EmailSignup />
    </PageLayout>
  );
}

